export const queryFilter = (route) => {
    return route.query;
};

export const composeHttpQuery = (data) => {
    const strOut = Object.entries(data)
        .map((item) => {
            const key = item[0];
            const data = item[1];
            if (Array.isArray(data)) {
                const out = data.map((value) => {
                    return `${key}=${value}`;
                });
                return out.join('&');
            }
            return `${key}=${data}`;
        })
        .join('&');
    return `?${strOut}`;
};

export const composeAPIFilter = (currentPage, perPage, search, where, additionalFilters) => {
    const filter = {};
    filter.limit = perPage;
    filter.offset = (currentPage - 1) * perPage;
    if (Array.isArray(where) && where.length > 0 && search && search.length > 0) {
        where.forEach((item) => {
            filter[item] = search;
        });
    }
    if (additionalFilters && typeof additionalFilters === 'object') {
        Object.entries(additionalFilters).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                filter[key] = value;
            }
        });
    }
    return filter;
};

export const getActiveFilters = (filters) => {
    const result = {};
    for (const [key, filter] of Object.entries(filters)) {
        const value = filter.active?.toString() ?? '';
        if (value.length > 0) {
            result[key] = value;
        }
    }
    return result;
};

export const useFilter = () => {
    return {
        queryFilter: queryFilter,
        composeHttpQuery: composeHttpQuery,
        composeAPIFilter: composeAPIFilter,
        getActiveFilters: getActiveFilters,
    };
};

export default useFilter;
